import React from 'react';
import { ContentList, ContentListItem } from '../ContentList';
import { Download } from '../Download';
import { IFileItem } from '../../../types/api/FileItem';
import { PagePackState } from '../../../types/api/PagePackState';
import { ExtendedInfoStateIndicator } from '../ExtendedInfo';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';

export type AttachedFilesBaseList = {
  attachments?: IFileItem[];
  backgroundTransparent?: boolean;
};

export function AttachedFilesBaseList({ attachments = [], backgroundTransparent }: AttachedFilesBaseList) {
  return (
    <ContentList modifier={backgroundTransparent ? 'background-transparent' : undefined}>
      {attachments.map(attachment => (
        <ContentListItem key={attachment.id}>
          <div className="attached-files-base__download-container">
            {attachment.packState && attachment.packState === PagePackState.ONLY_DRAFT_VERSION
              ? (
                  <div className="attached-files-base__indicator-container">
                    <ExtendedInfoStateIndicator stateIndicatorStatus="red" tooltipPlacement={TooltipPlacement.TOP} />
                  </div>
                )
              : null}
            <Download {...attachment} />
          </div>
        </ContentListItem>
      ))}
    </ContentList>
  );
}
